import { combineReducers } from 'redux';
import {
  cleanErrorsAction,
  fetchFormAction,
  fetchFormSuccessAction,
  refreshErrorsAction,
  updateDataAction,
} from '../actions/form';
import { createReducer } from 'redux-create-reducer';
import dotProp from 'dot-prop-immutable';
import { addContactAction, selectContactAction } from '../actions/contacts';
import { addSiteAction, selectSiteAction } from '../actions/sites';

const isFetching = createReducer(false, {
  [fetchFormAction]: (state, action) => {
    return true;
  },
  [fetchFormSuccessAction]: (state, action) => {
    return false;
  },
});

const errors = createReducer([], {
  [refreshErrorsAction]: (state, action) => {
    return action.payload;
  },
  [cleanErrorsAction]: (state, action) => {
    return [];
  },
});

const zoneInitialState = {
  isOwner: undefined,
  buildingType: undefined,
  constructionDate: undefined,
  floorNumber: undefined,
  annexes: [],
  accessInfo: undefined,
  buildingSurface: undefined,
  buildingPerimeter: undefined,
  landSurface: undefined,
  landPerimeter: undefined,
};

const stateInitialState = {
  groundTypes: [],
  moistureTrace: undefined,
  moistureTraceComment: undefined,
  termiteTreatmentBefore: undefined,
  termiteTreatmentBeforeComment: undefined,
  termiteInNeighbourhood: undefined,
  termiteInNeighbourhoodComment: undefined,
};

const frameworkInitialState = {
  accessible: undefined,
  damagesObserved: undefined,
  damagesObservedComment: undefined,
  termitesObserved: undefined,
  termitesObservedComment: undefined,
  ilxObserved: undefined,
  ilxObservedComment: undefined,
  reinforceFramework: undefined,
  reinforceFrameworkComment: undefined,
  thermalInsulationProblem: undefined,
  thermalInsulationProblemComment: undefined,
  tileProblem: undefined,
  tileProblemComment: undefined,
};

const recommendationInitialState = {
  activeProtectionType: undefined,
  diagnosticComment: undefined,
  internalComment: undefined,
};

const visitState = {
  planningDate: undefined,
  planningTime: undefined,
  preplanningDate: undefined,
  primaryWorkerId: undefined,
  secondaryWorkerIds: undefined,
};

const initialState = {
  name: '',
  creationDate: '',
  contactId: undefined,
  siteId: undefined,
  zone: zoneInitialState,
  stateOfPlay: stateInitialState,
  analysis: undefined,
  framework: frameworkInitialState,
  recommendation: recommendationInitialState,
  visit: visitState,
  sitePlans: [],
  canPlan: false,
  zone_templates: [],
};

const form = createReducer(initialState, {
  [selectContactAction]: (state, action) => {
    return {
      ...state,
      contactId: action.payload,
    };
  },
  [selectSiteAction]: (state, action) => {
    return {
      ...state,
      siteId: action.payload,
    };
  },
  [addContactAction]: (state, action) => {
    return {
      ...state,
      contactId: action.payload.id,
    };
  },
  [addSiteAction]: (state, action) => {
    return {
      ...state,
      siteId: action.payload.id,
    };
  },
  [fetchFormSuccessAction]: (state, action) => {
    return {
      ...action.payload,
      errors: [],
    };
  },
  [updateDataAction]: (state, action) => {
    const { propName, propValue } = action.payload;
    return dotProp.set(state, propName, propValue);
  },
});

const formReducer = combineReducers({
  isFetching,
  form,
  errors,
});

export default formReducer;

export const getName = state => state.form.form.name;
export const getCreationDate = state => state.form.form.creationDate;
export const getSiteId = state => state.form.form.siteId;
export const getContactId = state => state.form.form.contactId;
export const getErrors = state => state.form.errors;
export const getVisit = state => state.form.form.visit;
export const getAccessInformation = state =>
  state.form.form.zone.accessInformation;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/reducers/form.js